import { toast } from 'sonner'
import SkillShortcut from './SkillShortcut'
import { SkillEnum } from '@/types'
import { formatUnderscoreCase } from '@/utils'

export const toastSkillIncrease = (skillKey: SkillEnum, level: number) => {
  toast.success(
    <div className="flex items-center gap-2">
      <SkillShortcut skill={skillKey} level={level} />
      <div>
        <div className="text-lg text-gray-600">🏆 Reached new skill level</div>
        <span className="text-lg">
          {formatUnderscoreCase(skillKey)} level increased to {level}!
        </span>
      </div>
    </div>
  )
}

export const toastOverallSkillIncrease = (level: number) => {
  toast.success(
    <div className="flex items-center gap-2">
      <div className="bg-blue-600 w-8 h-8 rounded flex items-center justify-center text-white font-bold">{level}</div>
      <div>
        <div className="text-lg text-gray-600">🏄‍♂️ Reached new surf level</div>
        <span className="text-lg">Overall skill level increased to {level}!</span>
      </div>
    </div>
  )
}

export const toastHeatVictory = (roundKey: string, heatNumber: number, score: number, position: number) => {
  toast.success(
    <div className="flex items-center gap-2">
      <div className="bg-green-600 w-8 h-8 rounded flex items-center justify-center text-white font-bold">
        {position}
      </div>
      <div>
        <div className="text-lg text-gray-600">🏄‍♂️ Heat Victory</div>
        <span className="text-lg">
          Won {formatUnderscoreCase(roundKey)} Heat {heatNumber} with {score.toFixed(1)} points!
        </span>
      </div>
    </div>,
    {
      duration: 3000
    }
  )
}

export const toastHeatElimination = (roundKey: string, heatNumber: number) => {
  toast.error(
    <div className="flex items-center gap-2">
      <div className="bg-red-200 w-8 h-8 rounded flex items-center justify-center text-white font-bold">❌</div>
      <div>
        <div className="text-lg text-gray-600">❌ Eliminated</div>
        <span className="text-lg">
          Eliminated in {formatUnderscoreCase(roundKey)} Heat {heatNumber}
        </span>
      </div>
    </div>,
    {
      duration: 3000
    }
  )
}

export const toastCompetitionVictory = (prize: number) => {
  toast.success(
    <div className="flex items-center gap-2">
      <div className="bg-yellow-500 w-8 h-8 rounded flex items-center justify-center text-white font-bold">1</div>
      <div>
        <div className="text-lg text-gray-600">🏆 Competition Victory</div>
        <span className="text-lg">Won the competition and ${prize.toLocaleString()}!</span>
      </div>
    </div>,
    {
      duration: 3000
    }
  )
}

export const toastGameActivated = () => {
  toast.success(
    <div className="flex items-center gap-2">
      <div className="w-10 h-10 rounded flex items-center justify-center text-white text-2xl">🎉</div>
      <div>
        <div className="text-xl font-bold text-emerald-600">Congratulations!</div>
        <span className="text-lg">Full game activated successfully! Enjoy the complete GOAT Surfer experience!</span>
      </div>
    </div>,
    {
      duration: 5000
    }
  )
}
